export const SHADOW = {
  "Shadow.100": {
    defaultValue: "shadow-100|Color.Shadow"
  },
  "Shadow.200": {
    defaultValue: "shadow-200|Color.Shadow"
  },
  "Shadow.300": {
    defaultValue: "shadow-300|Color.Shadow"
  },
  "Shadow.500": {
    defaultValue: "shadow-500|Color.Shadow"
  },
  "Shadow.100.Pos": {
    defaultValue: "shadow-100"
  },
  "Shadow.200.Pos": {
    defaultValue: "shadow-200"
  },
  "Shadow.300.Pos": {
    defaultValue: "shadow-300"
  },
  "Shadow.500.Pos": {
    defaultValue: "shadow-500"
  }
};
